import { render } from "./show_internet_state.vue?vue&type=template&id=bacb5142"
import script from "./show_internet_state.vue?vue&type=script&lang=js"
export * from "./show_internet_state.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__